import FeedbackPage from '@app-studio-web/ui/pages/FeedbackPage'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'dream_feedback'

export default function DreamFeedbackPage() {
  const submit = useSubmit()
  const { isUpdate, postToReactNative } = useUpdateMode()
  const [dreamSharingChoice, setDreamSharingChoice] = useState<string | null>(
    null,
  )
  const { t } = useTranslation()

  useEffect(() => {
    // Get the user's dream sharing choice from local storage
    const dreamSharingAnswer = localStorage.getItem('onboarding_answers')
    if (dreamSharingAnswer) {
      try {
        const parsed = JSON.parse(dreamSharingAnswer)
        setDreamSharingChoice(parsed.dream_sharing.answer_key)
      } catch (e) {
        console.error('Error parsing dream sharing answer:', e)
      }
    }
  }, [])

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const answer = {
      question_key: QUESTION_KEY,
      question: 'Dream onboarding completed',
      answer_key: 'completed',
      answer: 'completed',
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget, { method: 'post' })
    }
  }

  // Show different content based on user's dream sharing choice
  if (
    dreamSharingChoice === 'just for me, please some dreams are private spells'
  ) {
    return (
      <FeedbackPage
        emoji="🔒"
        heading={t('pages.onboarding.dreamFeedback.privacy.heading')}
        text={t('pages.onboarding.dreamFeedback.privacy.text')}
        onSubmit={onSubmit}
      />
    )
  }

  // Default content for other choices (shared sometimes, shared always)
  return (
    <FeedbackPage
      emoji="🔓"
      heading={t('pages.onboarding.dreamFeedback.sharing.heading')}
      text={t('pages.onboarding.dreamFeedback.sharing.text')}
      onSubmit={onSubmit}
    />
  )
}
